import { useSetLastId } from 'peach/scopes/company/LastCompanyIdProvider'

const PersonManager = ({ personId, children }) => {
  useSetLastId('personId', personId)

  return children
}

export default PersonManager
